import React from "react";
import Maitrise from "../Maitrise/Maitrise";
import OurPartners from "../OurPartners/OurPartners";
import OurPortfolio from "../OurPortfolio/OurPortfolio";
import OurTeam from "../OurTeam/OurTeam";
import OurValues from "../OurValues/OurValues";
import Team from "../Team/Team";
import WhoWeAre from "../WhoWeAre/WhoWeAre";
import "./homepageBody.css";
import Values from "../Values/Values";
import KnowHow from "../KnowHow/KnowHow";
const HomepageBody = (props) => {
  return (
    <div>
      {!props.openMenu ? (
        <>
          <WhoWeAre language={props.language} />
          {/* <Maitrise /> */}
          <KnowHow language={props.language} />
          <OurPortfolio language={props.language} />
          {/* <Team language={props.language} /> */}
          <OurTeam language={props.language} />
          <Values language={props.language} />
          <OurPartners language={props.language} />
        </>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default HomepageBody;
